/**
 * Cascadia locale — ko-KR (Korean, primary) — board-game-client copy.
 *
 * UI is NOT shared between playground and client (CLAUDE.md). This file is
 * intentionally cloned — it must stay in sync with the playground copy.
 * Key set mirrors en-US.ts exactly; i18n.test.ts enforces this.
 *
 * Sources:
 *   - Error codes: 02-rules-spec.md §11.3
 *   - Phase names, module labels, UI strings: docs/wireframes/board-game-client/cascadia.md
 */

export const koKR: Readonly<Record<string, string>> = {
  // --- Error codes (spec §11.3) ---
  ERR_PHASE_MISMATCH: "지금 단계에서는 이 동작을 할 수 없습니다.",
  ERR_NOT_ACTIVE_SEAT: "당신 차례가 아닙니다.",
  ERR_STALE_VERSION: "보드가 갱신되었습니다. 새로고침합니다.",
  ERR_TILE_OCCUPIED: "이미 타일이 놓인 칸입니다.",
  ERR_TILE_NOT_ADJACENT: "이미 놓인 타일 옆에만 놓을 수 있어요.",
  ERR_WILDLIFE_UNSUPPORTED: "이 타일에 해당 야생동물 자리가 없습니다.",
  ERR_WILDLIFE_SLOT_FILLED: "이미 야생동물이 놓인 타일입니다.",
  ERR_WILDLIFE_TILE_LANDMARKED:
    "랜드마크가 있는 타일에는 야생동물을 놓을 수 없습니다.",
  ERR_NATURE_INSUFFICIENT: "자연 토큰이 부족합니다.",
  ERR_MARKET_SLOT_EMPTY: "비어 있는 시장 슬롯입니다.",
  ERR_DECOUPLE_NOT_UNLOCKED:
    "먼저 자연 토큰을 써서 분리 드래프트를 잠금해제 하세요.",
  ERR_OPTIONAL_WIPE_NOT_TRIGGERED:
    "3개 동일 야생동물 조건이 충족되지 않았습니다.",
  ERR_OPTIONAL_WIPE_ALREADY_USED:
    "이번 턴에 이미 선택적 시장 청소를 사용했습니다.",
  ERR_LANDMARK_TRIGGER_MISSING:
    "5칸 회랑이 생기지 않아 랜드마크 잠금해제 불가.",
  ERR_LANDMARK_HABITAT_TAKEN: "이 서식지에는 이미 랜드마크를 두었습니다.",
  ERR_LANDMARK_CARD_UNAVAILABLE: "선택한 랜드마크 카드가 풀에 없습니다.",
  ERR_AUTO_WIPE_PENDING: "시장 자동 청소 중… 잠시만 기다리세요.",
  ERR_DECOUPLE_ALREADY_UNLOCKED:
    "이번 턴에 분리 드래프트는 이미 잠금해제 되었습니다.",
  ERR_INVALID_WIPE_SLOTS: "교체할 슬롯 선택이 올바르지 않습니다.",
  ERR_LEGAL_PLACEMENT_EXISTS:
    "가능한 배치가 있을 때는 야생동물을 돌려보낼 수 없습니다.",
  ERR_UNKNOWN_ACTION: "알 수 없는 동작입니다. 새로고침합니다.",
  ERR_NO_GAME_STATE: "게임이 시작되지 않았습니다.",

  // --- Turn phases (spec §6.2) ---
  phase_marketCheck: "시장 점검",
  phase_placeTile: "타일 배치",
  phase_placeWildlife: "야생동물 배치",
  phase_unlockLandmark: "랜드마크",
  phase_endTurn: "턴 종료",
  phase_scoring: "점수 계산",

  // --- Module labels ---
  module_landmarks: "랜드마크",
  module_solo: "솔로",
  module_family: "패밀리 변형",
  module_intermediate: "중급 변형",
  module_ksPromo: "KS 프로모",

  // --- Habitat names (spec §1.1) ---
  habitat_forest: "숲",
  habitat_mountain: "산",
  habitat_prairie: "초원",
  habitat_river: "강",
  habitat_wetland: "습지",

  // --- Wildlife species (spec §1.2) ---
  wildlife_bear: "곰",
  wildlife_elk: "엘크",
  wildlife_salmon: "연어",
  wildlife_hawk: "매",
  wildlife_fox: "여우",

  // --- Common game terms ---
  nature_token: "자연 토큰",
  score: "점수",
  turn: "턴",
  pass: "패스",
  end_turn: "턴 종료",

  // --- Button labels ---
  btn_start_game: "게임 시작",
  btn_confirm: "확정",
  btn_skip_wildlife: "야생동물 건너뛰기",
  btn_skip_landmark: "랜드마크 건너뛰기",
  btn_wipe_optional: "시장 청소",
  btn_spend_nature_decouple: "자연 토큰: 분리",
  btn_spend_nature_wipe: "자연 토큰: 일부 교체",
  btn_play_again: "새 게임",
  btn_back_to_lobby: "로비",
  btn_close: "닫기",
  btn_learn_more: "자세히",
  btn_skip: "건너뛰기",
};
